import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "link-arrow",
  "use": "link-arrow-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"link-arrow\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.6066 5.29289L5.65684 0.343162L4.94973 1.05027L9.89946 6L4.94973 10.9497L5.65684 11.6568L10.6066 6.70711L10.6066 6.70712L11.3137 6.00002L11.3137 6L11.3137 5.99998L10.6066 5.29287L10.6066 5.29289Z\" fill=\"#0284C7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol